import React from 'react';
import Button from '@mui/material/Button';

interface SummaryBarActionsProps {
  onStatusChange?: () => void;
  onAllocate?: () => void;
  onPartAction?: () => void;
  onTask?: () => void;
}

const greenBtnSx = {
  bgcolor: 'v4.accent',
  py: '5px',
  px: '10px',
  textTransform: 'none' as const,
  fontWeight: 600,
  fontSize: '11px',
  color: 'common.white',
  whiteSpace: 'nowrap',
  '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
};

export const SummaryBarActions: React.FC<SummaryBarActionsProps> = ({
  onStatusChange,
  onAllocate,
  onPartAction,
  onTask,
}) => (
  <>
    {onStatusChange && (
      <Button variant="contained" size="small" onClick={onStatusChange} sx={greenBtnSx}>
        Status
      </Button>
    )}
    {onAllocate && (
      <Button variant="contained" size="small" onClick={onAllocate} sx={greenBtnSx}>
        Allocate
      </Button>
    )}
    {onPartAction && (
      <Button variant="contained" size="small" onClick={onPartAction} sx={greenBtnSx}>
        Part Action
      </Button>
    )}
    {onTask && (
      <Button variant="contained" size="small" onClick={onTask} sx={greenBtnSx}>
        Tasks
      </Button>
    )}
  </>
);
